import type { PriceInfo } from "@/components/widgets/Chart/services/PriceService/PriceService";
import { getDateString } from "@/components/widgets/Revision/lib/helpers";
import type { RevisionExt } from "@/components/widgets/Revision/types";
import type { SeriesData } from "../../../types";

const extractValue = <T extends object>(item: T, keys: string[]): unknown => {
	return keys.reduce<unknown>(
		(acc, key) =>
			acc && typeof acc === "object"
				? (acc as Record<string, unknown>)[key]
				: undefined,
		item,
	);
};

export const mapData = (
	items: PriceInfo[] | RevisionExt[],
	keyPath: string,
	startTime?: string,
): SeriesData[] => {
	const keys = keyPath.split(".");

	return items
		.map((item) => {
			const value = extractValue(item, keys);
			if (typeof value !== "number") return null;

			const time =
				"date" in item
					? getDateString(item.date)
					: getDateString(new Date(item.time));
			if (startTime && startTime > time) return null;

			return { time, value };
		})
		.filter((item): item is SeriesData => item !== null);
};
